import {
  makeRequiredFieldsValidator,
  useFormState,
  useFormValidation,
} from '../../../hocs/useFormWithValidation';

import { PROFILE_FIELDS_TYPES } from '../../../constants/formFields';

export const initialState = {
  [PROFILE_FIELDS_TYPES.HOME_PHONE]: '',
  [PROFILE_FIELDS_TYPES.ADDRESS_1]: '',
  [PROFILE_FIELDS_TYPES.ADDRESS_2]: '',
  [PROFILE_FIELDS_TYPES.COUNTRY]: '',
  [PROFILE_FIELDS_TYPES.CITY]: '',
  [PROFILE_FIELDS_TYPES.STATE]: '',
  [PROFILE_FIELDS_TYPES.POSTAL_CODE]: '',
};

export const validateRequiredFields = () =>
  makeRequiredFieldsValidator([PROFILE_FIELDS_TYPES.STATE]);

export function useHomeAddressFormState(state, errors) {
  const { formState, handleFormChange } = useFormState({
    ...initialState,
    ...state,
  });
  const {
    validateErrors,
    clearErrors,
    addLocalValidateErrors,
  } = useFormValidation(errors);

  const isValid = validateRequiredFields()(formState);

  const setCountryValue = value =>
    handleFormChange({
      ...formState,
      [PROFILE_FIELDS_TYPES.COUNTRY]: value,
      [PROFILE_FIELDS_TYPES.STATE]: '',
      [PROFILE_FIELDS_TYPES.POSTAL_CODE]: '',
    });

  return {
    formState,
    handleFormChange,
    validateErrors,
    addLocalValidateErrors,
    setCountryValue,
    clearErrors,
    isValid,
  };
}



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/HomeAddress/useHomeAddressFormState.js